import React from 'react'
import PropTypes from 'prop-types'

const Link = (props) => (
  <a href={props.href} className='link'>{props.children}</a>
)

Link.propTypes = {
  href: PropTypes.string
}

Link.defaultProps = {
  href: '#'
}

export default Link


// WEBPACK FOOTER //
// ./src/ui/links/link.js